<template>
  <div class="school-detail">
    <div class="school-detail-header">
      <div>{{ name }}</div>
      <div class="header-back" @click="$router.go(-1)">返回 ></div>
    </div>
    <div class="school-detail-stat">
      <div class="school-detail-stat-header">
        <DateUnitAndPicker :areaId="areaId" @changeTimes="changeTimes" />
        <StatList :list="stats" />
      </div>
      <div class="school-detail-stat-divider">
        <div class="school-detail-stat-divider-left">激活码历史使用情况</div>
        <div class="school-detail-stat-divider-right"></div>
      </div>
      <div class="school-detail-stat-small">
        <div
          v-for="(item, index) in smallStats"
          :key="index"
          class="stat-small-item"
        >
          <div class="stat-small-item-type">{{ item.label }}</div>
          <div class="stat-small-item-total">{{ item.total }}</div>
        </div>
      </div>
    </div>
    <div class="school-detail-charts">
      <div class="school-detail-charts-left">
        <div v-loading="!loading" class="charts-left-top">
          <EchartBox
            routeName="SchoolDetail"
            v-if="loading"
            echartType="学生数"
            :areaId="areaId"
            :getStatFunc="getStudentStat"
            :boxHeight="280"
          />
        </div>
        <div v-loading="!loading" class="charts-left-bottom">
          <EchartBox
            routeName="SchoolDetail"
            v-if="loading"
            echartType="学生占比"
            :areaId="areaId"
            :getStatFunc="getStudentProportionStat"
            :boxHeight="280"
          />
        </div>
      </div>
      <div v-loading="!loading" class="school-detail-charts-right">
        <EchartBox
          routeName="SchoolDetail"
          v-if="loading"
          echartType="付费人数"
          echartTips="学生数按照开通激活码数量计算，部分激活码可能未交付学生使用"
          :areaId="areaId"
          :getStatFunc="getPayStudentStat"
          needFilterType="statType"
          :boxHeight="576"
        />
      </div>
    </div>
    <div class="school-detail-table">
      <CommonTable
        tableType="学生详情"
        :keys="studentKeys"
        :count="count"
        :list="studentList"
        @changePagingParams="changePagingParams"
        @download="download"
        :border="true"
      />
    </div>
  </div>
</template>

<script>
import { formatInc, exportXlsx } from '@/utils/common'
import constant from '@/utils/constant'
import { mapActions } from 'vuex'
import moment from 'moment'
import StatList from '../common/StatList'
import EchartBox from '../common/EchartBox'
import DateUnitAndPicker from '../common/DateUnitAndPicker'
import CommonTable from '../common/CommonTable'

export default {
  name: 'SchoolDetail',
  components: {
    StatList,
    EchartBox,
    DateUnitAndPicker,
    CommonTable,
  },
  data() {
    return {
      loading: false,
      stats: [],
      smallStats: [],
      filterParams: {},
      studentKeys: [
        {
          prop: 'username',
          label: '账号',
        },
        {
          prop: 'nickname',
          label: '昵称',
        },
        {
          prop: 'isCampus',
          label: '校本课',
        },
        {
          prop: 'is430',
          label: '社团课',
        },
        {
          prop: 'isOrg',
          label: '机构课',
        },
        {
          prop: 'isVip',
          label: '会员',
        },
        {
          prop: 'actiationAt',
          label: '激活',
        },
        {
          prop: 'registerAt',
          label: '注册日期',
        },
      ],
      count: 0,
      studentList: [],
      studentParams: {
        page: 1,
        pageSize: 10,
      },
    }
  },
  computed: {
    name() {
      return this.$route.query.name
    },
    areaId() {
      return this.$route.query.areaId
    },
    orgId() {
      return this.$route.query.orgId
    },
    schoolId() {
      return this.$route.query.schoolId
    },
    statKeys() {
      return [
        {
          label: '学生总数',
          key: 'activeStudentTotal',
          footerKey: 'weeklyAggStuActiveCount',
        },
        {
          label: '校本学生总数',
          key: 'studentCampusTotal',
          footerKey: 'weeklyStudentCampusActiveCount',
        },
        {
          label: '社团学生总数',
          key: 'student430Total',
          footerKey: 'weeklyStudent430ActiveCount',
        },
        {
          label: '付费激活码使用',
          key: 'pay430ActivateCodeTotal/payOrgActivateCodeTotal',
          pathname: 'PayDetail',
          pathQuery: {
            schoolId: this.schoolId,
            schoolName: this.name,
            scrollTo: 'code',
          },
        },
      ]
    },
    smallStatKeys() {
      return [
        {
          label: '免费校本激活',
          key: 'freeCampusActivateCodeTotal',
        },
        {
          label: '收费社团激活',
          key: 'pay430ActivateCodeTotal',
        },
        {
          label: '收费机构激活',
          key: 'payOrgActivateCodeTotal',
        },
        {
          label: '收费会员',
          key: 'payVipStudentTotal',
        },
      ]
    },
  },
  methods: {
    ...mapActions({
      getSchoolDetail: 'newStat/getSchoolDetail',
      getOrgStudentList: 'newStat/getOrgStudentList',
    }),
    changeTimes(params) {
      if (params.unit) {
        this.filterParams = params
        this.initStats()
      }
    },
    async initStats() {
      const filterTimes = {
        ...this.filterParams,
        unit: this.filterParams.unit === 'all' ? 'day' : this.filterParams.unit,
      }
      const regionStat = await this.getSchoolDetailStat(filterTimes)
      const yesterdaySchoolStat = await this.getYesterdaySchoolStat()
      const lastMonthSchoolStat = await this.getLastMonthSchoolStat()
      const lastWeekSchoolStat = await this.getLastWeekSchoolStat()
      this.stats = this.getStatList(
        regionStat[0],
        lastMonthSchoolStat[0],
        lastWeekSchoolStat[0]
      )
      this.smallStats = this.getSmallStat(yesterdaySchoolStat[0])
      if (this.loading === false) {
        this.loading = true
      }
      await this.onGetStudentList()
    },
    getStatList(
      yesterdaySchoolStat = {},
      lastMonthSchoolStat = {},
      lastWeekSchoolStat = {}
    ) {
      return this.statKeys.map(item => {
        let yesterdayTotal = yesterdaySchoolStat[item.key] || 0
        let lastMonthTotal = lastMonthSchoolStat[item.key] || 0
        let lastWeekTotal = lastWeekSchoolStat[item.key] || 0
        if (item.key.includes('/')) {
          const [leftKey, rightKey] = item.key.split('/')
          yesterdayTotal =
            yesterdaySchoolStat[leftKey] ||
            0 + yesterdaySchoolStat[rightKey] ||
            0
          lastMonthTotal =
            lastMonthSchoolStat[leftKey] ||
            0 + lastMonthSchoolStat[rightKey] ||
            0
          lastWeekTotal =
            lastWeekSchoolStat[leftKey] || 0 + lastWeekSchoolStat[rightKey] || 0
        }
        let { inc: monthInc, add: monthAdd } = formatInc(
          yesterdayTotal,
          lastMonthTotal
        )
        let { inc: weekInc, add: weekAdd } = formatInc(
          yesterdayTotal,
          lastWeekTotal
        )
        let statFooter = ''
        if (item.footerKey) {
          statFooter = `本周活跃学生 ${
            yesterdaySchoolStat[item.footerKey] || 0
          } 人`
        }
        return {
          label: item.label,
          total: item.totalFunc
            ? item.totalFunc(
                yesterdayTotal,
                yesterdaySchoolStat[item.denominatorKey]
              )
            : yesterdayTotal,
          monthInc,
          monthAdd,
          weekInc,
          weekAdd,
          statFooter,
          pathname: item.pathname,
          pathQuery: item.pathQuery,
        }
      })
    },
    getSmallStat(yesterdaySchoolStat = {}) {
      return this.smallStatKeys.map(item => {
        return {
          label: item.label,
          total: yesterdaySchoolStat[item.key] || 0,
        }
      })
    },
    async getSchoolDetailStat(params) {
      return await this.getSchoolDetail({
        ...params,
        areaId: this.areaId,
        orgId: this.orgId,
      })
    },
    async getYesterdaySchoolStat() {
      const yesterdayDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      return await this.getSchoolDetail({
        areaId: this.areaId,
        orgId: this.orgId,
        startTime: yesterdayDate,
        endTime: yesterdayDate,
      })
    },
    async getLastMonthSchoolStat() {
      const lastMonthEndDate = moment()
        .subtract(1, 'months')
        .endOf('month')
        .format('YYYY-MM-DD')
      return await this.getSchoolDetail({
        areaId: this.areaId,
        orgId: this.orgId,
        unit: 'month',
        startTime: lastMonthEndDate,
        endTime: lastMonthEndDate,
      })
    },
    async getLastWeekSchoolStat() {
      const lastWeekEndDate = moment()
        .subtract(1, 'weeks')
        .endOf('week')
        .add(1, 'days')
        .format('YYYY-MM-DD')
      return await this.getSchoolDetail({
        areaId: this.areaId,
        orgId: this.orgId,
        unit: 'week',
        startTime: lastWeekEndDate,
        endTime: lastWeekEndDate,
      })
    },
    async getStudentStat() {
      const yesterdaySchoolStat = await this.getYesterdaySchoolStat()
      const stat = yesterdaySchoolStat[0] || {}
      const xAxisData = ['一次付费', '二次付费', '三次付费及以上']
      const seriesData = [
        {
          type: 'bar',
          barWidth: '40%',
          data: [
            {
              value: stat.payStudentTotal || 0,
              itemStyle: {
                color: '#4e70f0',
                barBorderRadius: 4,
              },
            },
            {
              value: stat.payTwiceStudentTotal || 0,
              itemStyle: {
                color: '#00c5d2',
                barBorderRadius: 4,
              },
            },
            {
              value: stat.payThirdPlusStudentTotal || 0,
              itemStyle: {
                color: '#ffce2b',
                barBorderRadius: 4,
              },
            },
          ],
        },
      ]
      return {
        echartEl: 'student-stat',
        echartOptions: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: '6%',
            right: '10%',
            bottom: '6%',
            top: '10%',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            data: xAxisData,
            splitLine: { show: false },
            axisTick: { show: false },
          },
          yAxis: {
            type: 'value',
            minInterval: 1,
            splitLine: {
              lineStyle: {
                type: 'dashed',
              },
            },
            axisLine: { show: false },
            axisTick: { show: false },
          },
          series: seriesData,
        },
      }
    },
    async getStudentProportionStat() {
      const yesterdaySchoolStat = await this.getYesterdaySchoolStat()
      const stat = yesterdaySchoolStat[0] || {}
      const legendData = ['免费校本', '收费社团', '收费会员', '收费机构']
      let seriesData = [
        { value: stat.freeCampusStudentCount || 0, name: '免费校本' },
        { value: stat.pay430StudentCount || 0, name: '收费社团' },
        { value: stat.payVipStudentCount || 0, name: '收费会员' },
        { value: stat.payOrgStudentCount || 0, name: '收费机构' },
      ]
      seriesData = seriesData.filter(item => item.value > 0)
      return {
        echartEl: 'student-proportion-stat',
        echartOptions: {
          tooltip: {
            trigger: 'item',
            formatter: '{b}<br/>{c} ({d}%)',
          },
          legend: {
            right: '5%',
            bottom: '6%',
            orient: 'vertical',
            height: '40%',
            data: legendData,
          },
          series: [
            {
              type: 'pie',
              center: ['30%', '60%'],
              radius: ['30%', '60%'],
              label: {
                normal: {
                  formatter: '{b}\n{d}%',
                },
              },
              data: seriesData,
            },
          ],
        },
      }
    },
    async getPayStudentStat({ type }) {
      const yesterdaySchoolStat = await this.getYesterdaySchoolStat()
      const stat = yesterdaySchoolStat[0] || {}
      const xAxisData = ['免费学生数', '付费学生数']
      const seriesData = [
        {
          value:
            type === 'now'
              ? stat.freeStudentCount || 0
              : stat.freeStudentTotal || 0,
          symbol: constant.echartIconPeople,
          itemStyle: {
            color: '#38cfda',
          },
        },
        {
          value:
            type === 'now'
              ? stat.payStudentCount || 0
              : stat.payStudentTotal || 0,
          symbol: constant.echartIconPeople,
          itemStyle: {
            color: '#869CF4',
          },
        },
      ]
      return {
        echartEl: 'pay-stat',
        echartOptions: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
          },
          grid: {
            left: '6%',
            right: '6%',
            bottom: '6%',
            containLabel: true,
          },
          xAxis: {
            data: xAxisData,
            inverse: true,
            axisTick: { show: false },
            axisLabel: {
              margin: 30,
              fontSize: 14,
            },
            axisPointer: {
              label: {
                show: true,
                margin: 30,
              },
            },
          },
          yAxis: {
            splitLine: { show: false },
            axisLabel: { show: false },
            axisTick: { show: false },
            axisLine: { show: false },
          },
          series: {
            type: 'pictorialBar',
            label: {
              normal: {
                show: true,
                position: 'top',
                textStyle: {
                  fontSize: 16,
                },
              },
            },
            symbolRepeat: true,
            symbolSize: ['40%', '40%'],
            barCategoryGap: '10%',
            barMaxWidth: '20%',
            data: seriesData,
          },
        },
      }
    },
    async onGetStudentList() {
      const { count, rows } = await this.getStudentList()
      this.count = count
      this.studentList = rows
    },
    async getStudentList(noPage = false) {
      let params = {
        orgId: this.orgId,
        areaId: this.areaId,
        noPage,
      }
      if (noPage === false) {
        params = {
          ...params,
          'x-page': this.studentParams.page,
          'x-per-page': this.studentParams.pageSize,
        }
      }
      const { count, rows } = await this.getOrgStudentList(params)
      const list = rows.map(item => {
        return {
          username: item.username,
          nickname: item.nickname,
          isCampus: item.isCampus ? '√' : '',
          is430: item.is430 ? '√' : '',
          isOrg: item.isOrg ? '√' : '',
          isVip: item.isVip ? '√' : '',
          actiationAt:
            item.paracraftActivatedAt &&
            moment(item.paracraftActivatedAt).format('YYYY-MM-DD HH:mm'),
          registerAt:
            item.registerAt &&
            moment(item.registerAt).format('YYYY-MM-DD HH:mm'),
        }
      })
      return {
        count,
        rows: list,
      }
    },
    changePagingParams(paging) {
      this.studentParams = paging
      this.onGetStudentList()
    },
    async download() {
      const { rows } = await this.getStudentList(true)
      if (rows.length > 0) {
        exportXlsx('学生列表', this.studentKeys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
  },
}
</script>

<style lang='scss'>
.school-detail {
  .school-detail-header {
    display: flex;
    color: #333333;
    font-size: 20px;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    .header-back {
      color: #999;
      padding: 4px;
      cursor: pointer;
      &:hover {
        color: #2397f3;
      }
    }
  }
  .school-detail-stat-header {
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
    border-radius: 4px;
    padding: 24px 28px 32px 28px;
  }
  .school-detail-stat-divider {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 22px;
    .school-detail-stat-divider-left {
      letter-spacing: 2px;
      margin-right: 20px;
    }
    .school-detail-stat-divider-right {
      height: 2px;
      background: #dcdcde;
      margin-top: 2px;
      flex: 1;
    }
  }
  .school-detail-stat-small {
    display: flex;
    justify-content: space-between;
    height: 130px;
    margin-top: 22px;
    margin-bottom: 22px;
    .stat-small-item {
      width: 23.6%;
      background: #fff;
      box-shadow: 0px 0px 10px 0px rgba(92, 92, 93, 0.1);
      border-radius: 4px;
      box-sizing: border-box;
      padding: 16px 0px 0px 28px;
      .stat-small-item-type {
        color: #999999;
      }
      .stat-small-item-total {
        color: #333333;
        font-size: 40px;
        margin-top: 16px;
      }
    }
  }
  .school-detail-charts {
    display: flex;
    justify-content: space-between;
    height: 576px;
    & > div {
      width: 49.1%;
    }
    .school-detail-charts-left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .school-detail-table {
    margin-top: 20px;
  }
}
</style>